// Copyright (c) 2026 CTO's Club LLC. All rights reserved.

// Backend authorization refusals name the missing action and resource, e.g.
// "Missing permission TAKE_PAYMENT" or "Missing permission DISPLAY on
// PAYMENT_TRANSACTION". Those reasons belong in logs and diagnostics; users see
// a friendly explanation instead (BUG-267).
const RAW_AUTHORIZATION_REASON_PATTERN = /\bMissing permission\b|\bpermission\s+[A-Z][A-Z_]{2,}\b/u;

export const AUTHORIZATION_REFUSAL_MESSAGE =
    'You do not have permission to do this. Ask an administrator for access.';

/** Whether text is a raw backend authorization reason rather than user wording. */
export function isRawAuthorizationReason(text: string | null | undefined): boolean {
    return text !== null && text !== undefined && RAW_AUTHORIZATION_REASON_PATTERN.test(text);
}

/**
 * A friendly explanation of an authorization refusal. With an activity such as
 * "send e-invoices", it names what the role cannot do.
 */
export function describeAuthorizationRefusal(activity?: string): string {
    return activity === undefined
        ? AUTHORIZATION_REFUSAL_MESSAGE
        : `Your role can't ${activity} for this merchant. Ask an administrator for payment permissions.`;
}
